import React, { ComponentProps } from 'react';
import { SearchResults } from '../../types/Search.types';
import { Pagination, PaginationItemWithPageLink } from '../../_lib/components/Pagination';
import { asBlock, useBlockContext } from '../../_lib/BlockFetcher';
import { SearchForm } from './partials/SearchForm';
import { ContentSearchResults } from '../../components/blocks/SearchResults';
import { BlockType } from '../../types/api/ElementType';
import { FACETS } from '../../components/molecules/ResultListSettings/ResultListSettings.enums';

type ContentSearchProps = SearchResults & {
  pageItems?: PaginationItemWithPageLink[];
};

export const contentSearchFacets: FACETS[] = [
  FACETS.FQ_ARCHIVEDATE,
  FACETS.FQ_PAGETYPE,
  FACETS.FQ_PAGE_CATEGORY_TITLES,
  FACETS.FQ_VALIDDATE,
  FACETS.FQ_PACKSTATE,
];

export function ContentSearch({ pageItems, ...embedded }: ContentSearchProps) {
  const { blockLayout } = useBlockContext();
  return (
    <>
      <SearchForm type="content" showSwitchButtons wantedFacets={contentSearchFacets} searchResult={embedded} />
      {embedded && embedded.resultContents && embedded.resultContents.length > 0 ? (
        <ContentSearchResults blockLayout={blockLayout || 'large'} resultContents={embedded.resultContents} />
      ) : null}
      <Pagination pageItems={pageItems} />
    </>
  );
}

type ContentSearchTypes = BlockType.contentsearch;
export const ContentSearchBlock = asBlock<ContentSearchProps, ContentSearchTypes>(ContentSearch);
export type ContentSearchBlock = ComponentProps<typeof ContentSearch>;
